import { RefObject, useEffect, useState } from 'react';

interface IntersectionOptions {
  threshold: number;
}

export const useIsInView = (
  ref: RefObject<Element | null>,
  options?: IntersectionOptions
) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const current = ref?.current;

    if (!current) {
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      setIsInView(entry.isIntersecting);
    }, options);
    observer.observe(current);

    return () => current && observer.unobserve(current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, ref?.current]);

  return isInView;
};
